export class SoundConstants {
    public static MENU: string = "menu";
    public static PAUSE: string = "pause";
    public static GAME: string = "game";

    public static BUTTON_CLICK: string = "button_click";
}
